import React from "react";
import { AiFillEdit } from "react-icons/ai";
import { FaUser } from "react-icons/fa";

const ProfileBox = ({ user }) => {
  return (
    <div className="w-full bg-white py-5">
      <div className="flex items-center  mb-2 relative">
        <button className="block md:hidden text-rose-500 absolute top-2 right-2">
          <AiFillEdit className="text-lg" />
        </button>

        <div className="basis-1/4 flex justify-center ">
          <div className="flex justify-center w-fit items-center p-4 bg-rose-50 rounded-full">
            <FaUser className="text-2xl text-rose-500 " />
          </div>
        </div>
        <div className=" basis-grow ">

          <h1 className="text-gray-700 font-semibold">
            {user ? user.fullname : "Unknown"}
          </h1>
          <h2 className="text-xs text-gray-400 font-semibold py-1">
            {user ? user.email : "Unknown"}
          </h2>
          <h3 className=" text-xs text-gray-400 font-semibold ">
            {user ? user.phone : "Unknown"}

          </h3>
        </div>
      </div>
    </div>
  );
};

export default ProfileBox;
